import { type Table } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { FaFileCsv } from "react-icons/fa";

interface DataTableViewOptionsProps<TData> {
  table: Table<TData>;
  action?: () => void;
  access?: boolean;
}

export function DataTableViewOptions<TData>({
  table,
  access,
  action = () => null,
}: DataTableViewOptionsProps<TData>) {
  const hide_coach_csv = (() => {
    try {
      return (
        JSON.parse(localStorage.getItem("accessLevels") as string)
          .hide_coach_csv ?? "no_access"
      );
    } catch {
      return "no_access";
    }
  })();

  function handleClick() {
    action();
  }
  return (
    <div className="flex justify-between items-center gap-3">
      <Button
        access={hide_coach_csv !== "no_access"}
        className="bg-primary text-sm text-black flex items-center justify-center gap-1 h-8 px-2 min-w-[32px]"
        onClick={handleClick}
      >
        <FaFileCsv className="size-3.5 text-black shrink-0" />
        <span className="hidden sm:inline">Export CSV</span>
      </Button>
    </div>
  );
}
